// import gsap from 'gsap';
// import { SplitText } from 'gsap/SplitText';

import DetectController from '../../assets/js/controllers/detect';

// gsap.registerPlugin(SplitText);

export default class Wip {

	static selector = 'wip';

	isDesktop;

	constructor(container) {
		this.el = {
			container,
			assets: container.querySelectorAll(`.${this.constructor.selector}__assets li`),
			schedules: container.querySelectorAll(`.${this.constructor.selector}__schedule li`)
		};

		this.isDesktop = DetectController.isDesktop;

		if (this.el.assets.length) this.el.assets[0].classList.add('is-active');

		this.addEventListeners();
	}

	addEventListeners() {
		for (const schedule of this.el.schedules) {
			schedule.addEventListener(`${this.isDesktop ? 'mouseenter' : 'click'}`, this.#onScheduleMouseEnter);
		}
	}

	removeEventListeners() {
		for (const schedule of this.el.schedules) {
			schedule.removeEventListener(`${this.isDesktop ? 'mouseenter' : 'click'}`, this.#onScheduleMouseEnter);
		}
	}

	#onScheduleMouseEnter = (e) => {
		const currentIndex = parseInt(e.currentTarget.dataset.index);
		const wasActive = this.el.container.querySelector(`.${this.constructor.selector}__assets li.is-active`);

		if (wasActive) wasActive.classList.remove('is-active');
		this.el.assets[currentIndex].classList.add('is-active');
	}

	destroy() {
		this.removeEventListeners();
	}

}
